import { endpointExtPendingOrder } from "../../main/services/endpoints"
import { FetchDataOptions } from "modules/main/services/fetchData";
import { OrderSummary } from "../types/order-summary";



//TODO - Use the same hook of other fetchs
export const pendingOrders = ():Promise<OrderSummary> => {
    const defaultOptions:FetchDataOptions = {
        method:"GET",
        headers:{},
        body:undefined,
        credentials:"include",
    }
    return fetch(endpointExtPendingOrder,{
            method:defaultOptions.method,
            headers:defaultOptions.headers,
            body:JSON.stringify(defaultOptions.body),
            credentials:defaultOptions.credentials})
            .then((response) => response.json())
            .catch((error) =>{throw error});
}